import { render, staticRenderFns } from "./image-slider.vue?vue&type=template&id=7a3b3afd&"
import script from "./image-slider.vue?vue&type=script&lang=js&"
export * from "./image-slider.vue?vue&type=script&lang=js&"
import style0 from "./image-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a3b3afd')) {
      api.createRecord('7a3b3afd', component.options)
    } else {
      api.reload('7a3b3afd', component.options)
    }
    module.hot.accept("./image-slider.vue?vue&type=template&id=7a3b3afd&", function () {
      api.rerender('7a3b3afd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/venveo-slider/components/image-slider.vue"
export default component.exports